import React from 'react';
import { ProductLineTitle } from '@insurancemenu/imenu-components-lib/dist/components';
import { ProductLineId, OptionType } from '@insurancemenu/imenu-components-lib/dist/types';
import { ProductLineInterestSelection } from 'types/electionService';
import { InterestSelectStyled } from './styles';
import { SUB_PRODUCT_SELECT_TEST_ID } from '../../../../constants';

interface Props {
  subscriberId: string;
  value: ProductLineInterestSelection;
  productLineId: ProductLineId;
  options: OptionType[];
  isEditable?: boolean;
  onInterestSelectionChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const ProductLineInterestSelect: React.FC<Props> = ({
  subscriberId,
  productLineId,
  value,
  options,
  isEditable = false,
  onInterestSelectionChange,
}) => {
  return (
    <InterestSelectStyled
      $isDisabled={!isEditable}
      id={`interest-select-${subscriberId}-${productLineId}`}
      name={`interest-select-${subscriberId}-${productLineId}`}
      value={value}
      label={<ProductLineTitle productLineId={productLineId} />}
      width="100%"
      options={options}
      disabled={!isEditable}
      placeholder="--Make election--"
      onChange={onInterestSelectionChange}
      data-test-id={SUB_PRODUCT_SELECT_TEST_ID}
    />
  );
};

export default ProductLineInterestSelect;
